import { PropTypes } from "prop-types"

import Translate from "../Translate"
import Modal from "../Modal"

export function MapModal({ children, isOpen, onClose }) {
  return (
    <Translate>
      {({ translate }) => (
        <Modal
          cssClassName="oj-map-modal"
          contentLabel={translate("accessMapModalTitle")}
          isOpen={isOpen}
          onClose={onClose}
        >
          <Modal.Content>{children}</Modal.Content>
        </Modal>
      )}
    </Translate>
  )
}

MapModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
}

export default MapModal
